import VerifiedIcon from '../../../../../assets/images/icons/icon-review-verified.svg';
import UnverifiedIcon from '../../../../../assets/images/icons/icon-review-unverified.svg';
import UnpublishedIcon from '../../../../../assets/images/icons/icon-review-suspicious.svg';

export enum SourceOptionsFilter {
  AllSource = '',
  VroomVroom = 'VroomVroom',
  Ekomi = 'Ekomi',
  Trustpilot = 'Trustpilot',
}

export enum StatusOptionsFilter {
  AllStatus = '',
  Verified = 'verified',
  Unverified = 'unverified',
}

export enum StatusCategories {
  verified = 'verified',
  unverified = 'unverified',
  unpublished = 'unpublished',
}

export const sourceOptions = [
  {
    text: 'Tous les avis',
    value: SourceOptionsFilter.AllSource,
  },
  {
    text: 'VroomVroom',
    value: SourceOptionsFilter.VroomVroom,
  }, {
    text: 'Ekomi',
    value: SourceOptionsFilter.Ekomi,
  }, {
    text: 'Trustpilot',
    value: SourceOptionsFilter.Trustpilot,
  },
];

export const statusOptions = [
  {
    text: 'Tous les avis',
    value: StatusOptionsFilter.AllStatus,
  },
  {
    text: 'Vérifiés',
    value: StatusOptionsFilter.Verified,
  },
  {
    text: 'Non-vérifiés',
    value: StatusOptionsFilter.Unverified,
  },
];

export const statusTitle = {
  [StatusCategories.verified]: 'Avis vérifié',
  [StatusCategories.unverified]: 'Avis non vérifié',
  [StatusCategories.unpublished]: 'Avis suspect',
};

export const statusIcon = {
  [StatusCategories.verified]: VerifiedIcon,
  [StatusCategories.unverified]: UnverifiedIcon,
  [StatusCategories.unpublished]: UnpublishedIcon,
};

export const statusColors = {
  [StatusCategories.verified]: '#51e3ae',
  [StatusCategories.unverified]: '#f6b65c',
  [StatusCategories.unpublished]: '#f74656',
};
